import { TippyV2 } from "@circle-react/components/shared/TippyV2";
import { Typography } from "@circle-react-uikit/Typography";

interface InformationProps {
  hide?: boolean;
  text?: string;
  tooltipText?: string;
}

export const Information = ({ tooltipText, text, hide }: InformationProps) => {
  if (hide) return null;

  return (
    <TippyV2 content={tooltipText} className="cursor-pointer pr-3">
      <Typography.LabelSm color="text-default">{text}</Typography.LabelSm>
    </TippyV2>
  );
};
